// extracted by mini-css-extract-plugin
export default {"outerBox":"HVLogo_module-NX2CDPYF_outerBox__rOOIz","textStyle":"HVLogo_module-NX2CDPYF_textStyle__l6jm3"};